import React from 'react';
import Chart from 'react-apexcharts';

const RadialBarChart = ({data=[]}) => {
  // Define your chart options and data

  var options = {
    chart: {
      height: 150,
      type: "radialBar",
    },
    series: [67],
    colors: ["red"],
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: '#333',
          startAngle: -90,
          endAngle: 90,
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            fontSize: "15px",
            show: true
          }
        }
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "red",
        type: "horizontal",
        gradientToColors: ["red"],
        stops: [0, 100]
      }
    },
    stroke: {
      lineCap: "butt"
    },
    labels: ["Progress"]
  };


  const series = data;  // Data corresponding to the labels

  return (
    <div>
      {/* <h2>Fruit Consumption Pie Chart</h2> */}
      <Chart options={options} series={series} type="radialBar" width="200" />
    </div>
  );
};

export default RadialBarChart;
